export const ROUTES = {
  LOGIN: '/login',
  ONBOARDING: '/onboarding',
  DASHBOARD: '/dashboard',
  WHATSAPP: '/whatsapp',
  AGENT_CONFIG: '/agent-config',
  KNOWLEDGE_BASE: '/knowledge-base',
  PLAYGROUND: '/playground',
  CONVERSATIONS: '/conversations',
  CAMPAIGNS: '/campaigns',
  CAMPAIGN_NEW: '/campaigns/new',
  CAMPAIGN_DETAIL: (id: string) => `/campaigns/${id}` as const,
  CAMPAIGN_DETAIL_PATTERN: '/campaigns/:id',
  CONTACTS: '/contacts',
  TAGS: '/tags',
  TEMPLATES: '/templates',
  TEMPLATE_NEW: '/templates/new',
  TEMPLATE_EDIT: (id: string) => `/templates/${id}/edit` as const,
  TEMPLATE_EDIT_PATTERN: '/templates/:id/edit',
  API_KEYS: '/keys',
  TEAM: '/team',
  ANALYTICS: '/analytics',
  BILLING: '/billing',
  PAYMENT_CALLBACK: '/billing/payment-callback',
  SETTINGS: '/settings',
} as const;
